import { useEffect } from 'react';

const FluidCustomAd = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('Adsense error', e);
    }
  }, []);

  return (
    <ins className="adsbygoogle"
      style={{ display: 'block',padding:'10px' }}
      data-ad-format="fluid"
      data-ad-layout-key="-fb+5w+4e-db+86"
      data-ad-client="ca-pub-4093862221318795"
      data-ad-slot="7366373522"
    />
  );
};

export default FluidCustomAd;
